import React, { Component } from 'react'
import {withRouter} from 'react-router-dom';

class RippleLink extends Component {

    constructor(props){
        super(props)
        this.state = {animate: ""}
        this._ripple_click = this._ripple_click.bind(this)
    }

    _ripple_click(e){
        if(this.timeout!==null){ clearTimeout(this.timeout); }
        // const offsetX = typeof e.offsetX == "number" ? e.offsetX : e.touches[0].clientX - e.target.getBoundingClientRect().left;
        // const offsetY = typeof e.offsetY == "number" ? e.offsetY : e.touches[0].clientY - e.target.getBoundingClientRect().top;
        this.setState({ animate: "animate" })
        const me = this
        this.timeout = setTimeout(function(){
            me.setState({ animate: ""})
            me.props.url 
                ?  me.props.history.push(me.props.url) 
                : ( me.props.onClick && me.props.onClick() )
        }, 250)
    }

    render() {
        return (
            <a onClick={ (e) => { this._ripple_click() } } className={ [ this.props.css, `ripple ${ this.state.animate }` ].join(" ") } style={ this.props.styles }>
                <div className="wave"></div>
                {this.props.children}
            </a>
        )
    }
}


export default withRouter(RippleLink)



// WEBPACK FOOTER //
// ./src/components/ripplelink/index.js